module.exports = __webpack_public_path__ + "img/product_top.6e9642e1.png";